export default __webpack_public_path__ + "static/medialinq-knapp-exempel-a5402dd98bc64e37279c7b2708bdd370.png";